import type { AuthProvidersDto } from "@stylingcv/dto";
import { useQuery } from "@tanstack/react-query";

import { AUTH_PROVIDERS_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";

export const getAuthProviders = async () => {
  const response = await axios.get<AuthProvidersDto>(`/auth/providers`);

  return response.data;
};

export const useAuthProviders = () => {
  const {
    error,
    isPending: loading,
    data: providers,
  } = useQuery({
    queryKey: [AUTH_PROVIDERS_KEY],
    queryFn: getAuthProviders,
    refetchOnMount: false,        // Don't refetch on every mount - use cached data
    refetchOnWindowFocus: false,  // Don't refetch when window regains focus
    retry: 1,                     // Only retry once on failure
    staleTime: 1000 * 60 * 30,    // 30 minutes - providers almost never change
    gcTime: 1000 * 60 * 60,       // Keep in cache for 1 hour
  });

  return { providers, loading, error };
};
